"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const yup = require("yup");
exports.COMMENT_VALIDATIONS = {
    TEXT_MIN: 1,
    TEXT_MAX: 10000,
};
exports.COMMENT_ERR_MESSAGES = {
    COMMENT_TEXT_NOT_VALID: `Comment should be between ${exports.COMMENT_VALIDATIONS.TEXT_MIN} and 
    ${exports.COMMENT_VALIDATIONS.TEXT_MAX} characters`,
    COMMENT_EMPTY: "comment can not be empty",
    COMMENT_NOT_FOUND: "comment not found",
    NOTING_TO_UPDATE: "nothing to update",
};
exports.commentTextValidation = yup
    .string()
    .min(exports.COMMENT_VALIDATIONS.TEXT_MIN, exports.COMMENT_ERR_MESSAGES.COMMENT_TEXT_NOT_VALID)
    .max(exports.COMMENT_VALIDATIONS.TEXT_MAX, exports.COMMENT_ERR_MESSAGES.COMMENT_TEXT_NOT_VALID)
    .required();
//# sourceMappingURL=comment.js.map


//////////////////
// WEBPACK FOOTER
// ../common/dist/yupSchemas/comment.js
// module id = 615
// module chunks = 0